import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../core/settings.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
  ) { }

  getSubscriptions(data: any) {
    if (data === undefined) {
      data = {};
    }
    let page = 1;
    if (data.page !== undefined) {
      page = data.page;
    }
    let limit = 100;
    if (data.limit !== undefined) {
      limit = data.limit;
    }
    let sortField = 'id';
    if (data.sortField !== undefined) {
      sortField = data.sortField;
    }
    let sortType = 'desc';
    if (data.sortType !== undefined) {
      sortType = data.sortType;
    }
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'subscription/list', {
        params: {
          page: page.toString(),
          limit: limit.toString(),
          sortBy: sortField + ' ' + sortType
        }
      }
    );
  }

  getSubscription(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'subscriptions/' + id.toString()
    );
  }

  getSubscriptionItems(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'subscriptions/' + id.toString() + '/item/list'
    );
  }

  deleteSubscription(id: number) {
    return this.httpClient.delete(
      this.settingsService.getSetting('apiHost') + 'subscriptions/' + id.toString()
    );
  }
}
